export * from '@sportworld/js-sdk/src/constants/login'

export const welcomeScreenTitleData = {
  title: 'worldOfSportsInApp',
}

export const titleData: { [key: string]: { [key: string]: string } } = {
  created_register: {
    title: 'registerCreated',
    description: 'registerCreatedDescription',
  },
  created_login: {
    title: 'loginCreated',
    description: 'loginCreatedDescription',
  },
  created_checkout: {
    title: 'checkoutCreated',
    description: 'checkoutCreatedDescription',
  },
  created_selfService: {
    title: 'selfServiceCreated',
    description: 'selfServiceCreatedDescription',
  },
  entered_register: {
    title: 'registerEntered',
    description: 'registerEnteredDescription',
  },
  entered_login: {
    title: 'loginEntered',
    description: 'loginEnteredDescription',
  },
  entered_checkout: {
    title: 'checkoutEntered',
    description: 'checkoutEnteredDescription',
  },
  entered_selfService: {
    title: 'selfServiceEntered',
    description: 'selfServiceEnteredDescription',
  },
  error: {
    title: 'errorTitle',
    description: 'errorLostConnection',
  },
  timedOut_register: {
    title: 'register',
    description: 'mobileOrComputerLogin',
  },
  timedOut_login: {
    title: 'login',
    description: 'mobileOrComputerLogin',
  },
  timedOut_checkout: {
    title: 'checkout',
    description: 'mobileOrComputerLogin',
  },
  timedOut_selfService: {
    title: 'selfservice',
    description: 'mobileOrComputerLogin',
  },
  completed_register: {
    title: 'registerSuccess',
    description: 'registerSuccessDescription',
  },
  completed_login: {
    title: 'loginSuccess',
    description: 'loginSuccessDescription',
  },
  completed_checkout: {
    title: 'checkoutSuccess',
    description: 'checkoutSuccessDescription',
  },
  completed_selfService: {
    title: 'selfServiceSuccess',
    description: 'selfServiceSuccessDescription',
  },
  authenticated_checkout: {
    title: 'checkoutLoginSuccess',
    description: 'checkoutLoginSuccessDescription',
  },
}
